import React from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Header from '@/components/Header';
import { User, SignOut } from '@phosphor-icons/react';
import { motion } from 'framer-motion';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const ProfilePage = ({ user }) => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await axios.post(`${BACKEND_URL}/api/auth/logout`, {}, { withCredentials: true });
      toast.success('Logged out successfully');
      navigate('/');
      setTimeout(() => window.location.reload(), 100);
    } catch (error) {
      toast.error('Failed to logout');
    }
  };

  return (
    <div className="min-h-screen bg-stone-50">
      <Header user={user} />
      <main className="pt-24 pb-16 px-6" data-testid="profile-page">
        <div className="max-w-4xl mx-auto space-y-6">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="bg-white border border-stone-200 shadow-sm rounded-2xl p-6 md:p-8 flex items-center justify-between"
            data-testid="profile-header"
          >
            <div className="flex items-center gap-4">
              <div className="w-16 h-16 rounded-full bg-[#1A4331] text-white flex items-center justify-center text-2xl font-heading">
                {user?.name?.[0] || <User size={28} weight="duotone" />}
              </div>
              <div>
                <h2 className="text-2xl font-semibold text-[#1C1917] font-heading">{user?.name}</h2>
                <p className="text-stone-600">{user?.email}</p>
              </div>
            </div>
            <button onClick={handleLogout} className="flex items-center gap-2 bg-stone-900 text-white px-6 py-3 rounded-full font-medium hover:bg-stone-800 transition-all duration-200" data-testid="logout-btn">
              <SignOut size={20} weight="bold" />
              Logout
            </button>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.15 }}
            className="bg-gradient-to-br from-[#0F2A20] to-[#1A4331] text-white rounded-2xl p-6 md:p-8"
            data-testid="wellness-cta"
          >
            <p className="text-xs uppercase tracking-[0.16em] text-[#34D399] font-bold mb-2">Nova Wellness</p>
            <h3 className="text-2xl font-semibold font-heading mb-2">Personalized guidance from real experts</h3>
            <p className="text-stone-300 mb-5">Book a verified nutritionist, coach, therapist or yoga instructor tailored to your goals.</p>
            <button
              onClick={() => navigate('/wellness/find')}
              className="bg-[#34D399] text-[#0F2A20] px-6 py-3 rounded-full font-bold hover:bg-[#10B981] transition-all"
              data-testid="profile-wellness-cta"
            >
              Browse Professionals
            </button>
          </motion.div>
        </div>
      </main>
    </div>
  );
};

export default ProfilePage;
